import * as z from "../../../framework";

export function fixStoredll() {
    var loginData = $.parseJSON(localStorage.loginData);
    var companyData = $.parseJSON(localStorage.companyData);

    // convert login & company data to obj if necessary
    if (Array.isArray(loginData.LocalizedLabels)) {
        let temp = {};
        $.each(loginData.LocalizedLabels, function (index, result) {
            temp[result.Key] = result.Value;
        });
        loginData.LocalizedLabels = temp;
        localStorage.loginData = JSON.stringify(loginData);
    }
    if (Array.isArray(companyData.LocalizedLabels)) {
        let temp = {};
        $.each(companyData.LocalizedLabels, function (index, result) {
            temp[result.Key] = result.Value;
        });
        companyData.LocalizedLabels = temp;
        localStorage.companyData = JSON.stringify(companyData);
    }
}

export function initllRefresh() {
    fixStoredll();
}

function isUserLoggedInAndCompanySelected() {
    return localStorage.loginData && localStorage.companyData;
}
